import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Article } from 'src/app/interfaces/article';
import { PreorderService } from 'src/app/services/preorder.service';

@Component({
    selector: 'app-article-preorder-modal',
    templateUrl: './article-preorder-modal.component.html',
    styleUrl: './article-preorder-modal.component.scss',
    standalone: false
})
export class ArticlePreorderModalComponent {
  @Input() article: Article;

  get articleType() {
    return this.article?.article_type?.includes('P') ? 'Parts' : 'Bicycles';
  }

  constructor(public modal: NgbActiveModal, private preorderService: PreorderService) {

  }

  ngOnInit() {
    const articleType = this.article.article_type === "F" ? "Bicycles" : "Parts";
    this.preorderService.preorderType = articleType;
  }


}
